var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFtxChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 15,
    viewBox: "0 0 43 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 15,
    rx: 2,
    fill: "#F4F5FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14232_49933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9643 6.58884V7.61624H24.3685V8.63696H21.9643V10.2388H20.4237V5.56745H24.6953V6.58884H21.9643Z",
    fill: "#131112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9281 6.61553H25.2552V5.56745H30.1337V6.61553H28.4687V10.2388H26.9281V6.61553Z",
    fill: "#131112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.226 10.2388L33.0979 8.79041L31.9852 10.2388H30.2268L32.2109 7.87642L30.3125 5.56745H32.0475L33.1368 6.91574L34.2105 5.56745H35.8756L33.977 7.82305L36 10.2388H34.226Z",
    fill: "#131112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8595 11.25H13.1838V9.25725H10.8595V11.25Z",
    fill: "#84D6D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.246 6.50268H10.8595V8.49609H15.246H16.0438V6.50334H15.246V6.50268Z",
    fill: "#33BBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8595 3.74992V5.74268H18.0597V3.74992H10.8595Z",
    fill: "#11A9BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.49609H10.3236V6.50268H8V8.49609Z",
    fill: "#33BBC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14232_49933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 7.5,
    fill: "white",
    transform: "translate(8 3.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtxChip);
export default __webpack_public_path__ + "static/media/FTX_chip.5ea96bd912abd27827a2a26c388c8d35.svg";
export { ForwardRef as ReactComponent };